/**
 * Liens des réseaux sociaux SEGAROW
 */

export const SOCIAL_LINKS = {
  YOUTUBE: 'https://www.youtube.com/channel/UCXOV1tTxtNeJB8TaHhoQIKQ',
  YOUTUBE_MAIN: 'https://www.youtube.com/@segarow',
  YOUTUBE_WATCH: 'https://www.youtube.com/watch?v=',
  TWITCH: 'https://www.twitch.tv/segarow_tv',
  TIKTOK: 'https://www.tiktok.com/@segarow.clips',
  INSTAGRAM: 'https://www.instagram.com/segarow.news',
  DISCORD: 'https://discord.gg/zcQKeNYqja'
};

export default SOCIAL_LINKS;